import './Skills.css';
import TechIcon from '../../components/TechIcon';

const categories = [
  {
    label: 'Languages & Runtimes',
    skills: ['TypeScript', 'JavaScript', 'Python', 'Node.js'],
  },
  {
    label: 'Frontend',
    skills: ['React', 'Next.js', 'Angular'],
  },
  {
    label: 'Backend & APIs',
    skills: ['NestJS', 'FastAPI', 'Express', 'REST', 'GraphQL', 'Kafka'],
  },
  {
    label: 'Databases',
    skills: ['MongoDB', 'PostgreSQL', 'MySQL', 'SQL Server', 'Redis'],
  },
  {
    label: 'Cloud & DevOps',
    skills: ['AWS Cognito', 'Lambda', 'EC2', 'S3', 'Docker', 'New Relic'],
  },
  {
    label: 'AI & Tooling',
    skills: ['Amazon Bedrock', 'RAG Pipelines', 'OpenAI API', 'Anthropic API', 'Cursor', 'Claude'],
  },
];

export default function Skills() {
  return (
    <section id="skills">
      <div className="container">
        <div className="skills-inner">
          <div className="skills-left">
            <p className="section-label">Toolkit</p>
            <h2 className="section-title" style={{ marginBottom: 0 }}>Technical<br />Skills</h2>
          </div>

          <div className="skills-categories">
            {categories.map(cat => (
              <div key={cat.label}>
                <div className="skill-category-label">{cat.label}</div>
                <div className="skill-chips">
                  {cat.skills.map(s => (
                    <div key={s} className="skill-chip">
                      <TechIcon name={s} size={13} />
                      {s}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
